/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
import { DataGrid } from '../../../components/datagrid';
import { SearchFilter } from '../../../components/inputs/filters/search';
import { PageTitle } from '../../../components/PageTitle';
import { useFetch } from '../../../hooks/useFetch';
import { ReturnButton } from '../../../components/buttons/ReturnButton';
import { getCellImage, getCellStatus } from '../../../utils/FormatFunctions';
import Loader from '../../../components/Loader';
import { useAuth } from '../../../providers/auth';

export function ResponsibleChildrensPage() {
  const { parentId } = useParams();
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/children?parent_id=${parentId}`;
  const { user } = useAuth();
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const {
    requestApi: reqApiParent,
    data: dataParent,
    loading: loadingParent,
    error: errorParent,
  } = useFetch('/v1/admin/classes');
  const navigate = useNavigate();

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'image', label: 'Imagem' },
    { name: 'name', label: 'Nome' },
    { name: 'team.institution.name', label: 'Instituição' },
    { name: 'team.school_class.name', label: 'Módulo' },
    { name: 'team.teacher.name', label: 'Professor' },
  ];

  useEffect(() => {
    reqApiParent('get', null, `/v1/admin/users/${parentId}`);
  }, [parentId]);

  if (loadingParent) {
    return <Loader />;
  }

  if (errorParent) {
    return <ErrorState onRetry={() => reqApiParent('get', null, `/v1/admin/users/${parentId}`)} />;
  }
  const groupIds = user?.group?.id;

  return (
    <Box>
      <Flex>
        <ReturnButton previousPage="responsible" mb={5} />
        <PageTitle>Filhos do responsável {dataParent?.data?.name}</PageTitle>
      </Flex>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 7 && groupIds !== 3}
        loading={loading}
        rowActions={{
          show: false,
          edit: groupIds !== 7 && groupIds !== 6 && groupIds !== 3,
          delete: groupIds !== 7 && groupIds !== 6,
        }}
        columnWithAction={[
          {
            name: 'meetings',
            columnAction: (rowItem) => (
              <Button
                textTransform="uppercase"
                colorScheme="button.primary"
                onClick={() => navigate(`${rowItem.id}/meetings`)}
              >
                Ver encontros
              </Button>
            ),
          },
          //   {
          //     name: 'status',
          //     columnAction: rowItem => (
          //       <SwitchInput
          //         values={rowItem}
          //         value={rowItem.status}
          //         changeStatus={(checked, values) =>
          //           onToggleSwitch({
          //             requestToggle,
          //             method: 'patch',
          //             checked,
          //             name: 'user',
          //             path: `${baseApiUrl}/globals/status/${values.id}`,
          //             variable: 'status',
          //           })
          //         }
          //       />
          //     ),
          //   },
        ]}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
          {
            field: 'image',
            formatField: (values) => getCellImage(values, true),
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />
    </Box>
  );
}
